const solarEkipman = [
  {
    "title": "M8X25mm Vida",
    "image": "https://cw-enerji.com/images/product/1600_m8x25mm-vida_0.png",
    "text": "",
    "variants": []
  },
  {
    "title": "IP68 1500V Disi-Erkek Baglantı Konnektörü Seti",
    "image": "https://cw-enerji.com/images/product/1444_ip68-1500v-disi-erkek-baglanti-konnektoru-seti_0.jpg",
    "text": "- Bakır ve Gümüş Kaplama Bağlantı Malzemesi\n- Eklemeli Kilit Sistemi\n- Fiş Konnektörü Bağlantı Direnci : ≤ 5mΩ\n- Maksimum Sistem Voltajı : 1000V\n- Nominal Akım Kapasitesi:\n*22A(2,5mm2)\n*30A(4mm2, 6mm2)",
    "variants": []
  },
  {
    "title": "TommaTech 12V Moduler Series 1.5m Güç Kablosu Seti",
    "image": "https://cw-enerji.com/images/product/1460_tommatech-12v-moduler-series-15m-guc-kablosu-seti_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "TommaTech 48V 50Ah Lityum Batarya Haberleşme Kablosu",
    "image": "https://cw-enerji.com/images/product/1465_tommatech-tt4850-haberlesme-kablosu_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "M8X35mm Vida",
    "image": "https://cw-enerji.com/images/product/1601_m8x35mm-vida_0.png",
    "text": "",
    "variants": []
  },
  {
    "title": "Dikdörtgen Somun",
    "image": "https://cw-enerji.com/images/product/1602_dikdortgen-somun_0.webp",
    "text": "",
    "variants": []
  },
  {
    "title": "TommaTech Modular/Rack Series 25.6-51.2V LFP Güç Kablo Seti",
    "image": "https://cw-enerji.com/images/product/1379_tommatech-modularrack-series-256-512v-lfp-guc-kablo-seti_0.webp",
    "text": "Elektrolitik kalaylı, ince çok telli ve bükülü iletken, IEC 60228 uygun.\nÇift izoleli.\nÇapraz bağlı özel izolasyon malzemesi.\nÇapraz bağlı özel kılıf malzemesi.\nHalojen içermez.\nAşınmaya ve kesilmeye karşı dayanıklı.\nAlev geciktiricili ve yanmaya karşı dayanıklı.",
    "variants": []
  },
  {
    "title": "TommaTech LFP Lityum Batarya Topraklama Kablosu",
    "image": "https://cw-enerji.com/images/product/1383_tommatech-lfp-lityum-batarya-topraklama-kablosu_0.webp",
    "text": "Elektrolitik kalaylı, ince çok telli ve bükülü iletken, IEC 60228 uygun.\nÇift izoleli.\nÇapraz bağlı özel izolasyon malzemesi.\nÇapraz bağlı özel kılıf malzemesi.\nHalojen içermez.\nAşınmaya ve kesilmeye karşı dayanıklı.\nAlev geciktiricili ve yanmaya karşı dayanıklı.",
    "variants": []
  },
  {
    "title": "TommaTech Modular/Rack Series 25.6-51.2V LFP Haberleşme Kablosu",
    "image": "https://cw-enerji.com/images/product/1381_batarya-batarya-arasi-haberlesme-kablosu_0.jpg",
    "text": "Elektrolitik kalaylı, ince çok telli ve bükülü iletken, IEC 60228 uygun.\nÇift izoleli.\nÇapraz bağlı özel izolasyon malzemesi.\nÇapraz bağlı özel kılıf malzemesi.\nHalojen içermez.\nAşınmaya ve kesilmeye karşı dayanıklı.\nAlev geciktiricili ve yanmaya karşı dayanıklı.",
    "variants": []
  },
  {
    "title": "TommaTech Moduler Series 12.8V LFP Güç Kablo Seti",
    "image": "https://cw-enerji.com/images/product/1385_tommatech-moduler-series-128v-lfp-guc-kablo-seti_0.webp",
    "text": "Elektrolitik kalaylı, ince çok telli ve bükülü iletken, IEC 60228 uygun.\nÇift izoleli.\nÇapraz bağlı özel izolasyon malzemesi.\nÇapraz bağlı özel kılıf malzemesi.\nHalojen içermez.\nAşınmaya ve kesilmeye karşı dayanıklı.\nAlev geciktiricili ve yanmaya karşı dayanıklı.",
    "variants": []
  },
  {
    "title": "TommaTech Modular/Rack Series Batarya-Inverter Haberleşme Kablosu",
    "image": "https://cw-enerji.com/images/product/1382_tommatech-modularrack-series-batarya-inverter-haberlesme-kablosu_0.webp",
    "text": "Elektrolitik kalaylı, ince çok telli ve bükülü iletken, IEC 60228 uygun.\nÇift izoleli.\nÇapraz bağlı özel izolasyon malzemesi.\nÇapraz bağlı özel kılıf malzemesi.\nHalojen içermez.\nAşınmaya ve kesilmeye karşı dayanıklı.\nAlev geciktiricili ve yanmaya karşı dayanıklı.",
    "variants": []
  },
  {
    "title": "TommaTech ECO Series LFP Batarya Inverter Arası Güç Kablo Seti",
    "image": "https://cw-enerji.com/images/product/1386_tommatech-eco-series-lfp-batarya-inverter-arasi-guc-kablo-seti_0.webp",
    "text": "Elektrolitik kalaylı, ince çok telli ve bükülü iletken, IEC 60228 uygun.\nÇift izoleli.\nÇapraz bağlı özel izolasyon malzemesi.\nÇapraz bağlı özel kılıf malzemesi.\nHalojen içermez.\nAşınmaya ve kesilmeye karşı dayanıklı.\nAlev geciktiricili ve yanmaya karşı dayanıklı.",
    "variants": []
  },
  {
    "title": "TommaTech Modular/Rack Series Batarya Paralelleme Kablo Seti",
    "image": "https://cw-enerji.com/images/product/1380_tommatech-modularrack-series-batarya-paralelleme-kablo-seti_0.webp",
    "text": "Elektrolitik kalaylı, ince çok telli ve bükülü iletken, IEC 60228 uygun.\nÇift izoleli.\nÇapraz bağlı özel izolasyon malzemesi.\nÇapraz bağlı özel kılıf malzemesi.\nHalojen içermez.\nAşınmaya ve kesilmeye karşı dayanıklı.\nAlev geciktiricili ve yanmaya karşı dayanıklı.",
    "variants": []
  },
  {
    "title": "DC Kırmızı 1 Metre (10.0mm - Kesit) Solar Kablo",
    "image": "https://cw-enerji.com/images/product/3_tommatech-100mm-solar-kablo-pvi1-f-kirmizi-1-metre_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "EPDM Çatı Bandı",
    "image": "https://cw-enerji.com/images/product/1434_epdm-cati-bandi_0.jpg",
    "text": "Yapışkanlı EPDM Bantlar, sızdırmazlık ürünü olarak yapışkanlı yüzeyi sayesinde pratik ve kolay kullanım imkanı sunar.",
    "variants": []
  },
  {
    "title": "Ejot Vida",
    "image": "https://cw-enerji.com/images/product/1433_ejot-vida_0.webp",
    "text": "Fotovoltaik tesisatlar için ince duvarlı metal profillere bileşenleri ve dirsekleri bağlama:\nAyaklı dikiş sistemleri veya ön cımbız tutucuların ince cidarlı çelik altyapılara (mesela profilli saclar) montajı için için trapez levha flanşları\nRüzgar saptırıcı levhaların profil elemanlara montajı",
    "variants": []
  },
  {
    "title": "DC Siyah 1 Metre (10.0mm - Kesit) Solar Kablo",
    "image": "https://cw-enerji.com/images/product/2_tommatech-100mm-solar-kablo-pvi1-f-siyah-1-metre_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "DC Kırmızı 1 Metre (6.0mm - Kesit) Solar Kablo",
    "image": "https://cw-enerji.com/images/product/4_tommatech-60mm-solar-kablo-pvi1-f-kirmizi-1-metre_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "DC Siyah 1 Metre (6.0mm - Kesit) Solar Kablo",
    "image": "https://cw-enerji.com/images/product/439_tommatech-60mm-solar-kablo-pvi1-f-siyah-1-metre_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "DC Kırmızı 1 Metre (4,0mm - Kesit) Solar Kablo",
    "image": "https://cw-enerji.com/images/product/7_tommatech-40mm-solar-kablo-pvi1-f-kirmizi-1-metre_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "DC Siyah 1 Metre (4.0mm - Kesit) Solar Kablo",
    "image": "https://cw-enerji.com/images/product/10_tommatech-40mm-solar-kablo-pvi1-f-siyah-1-metre_0.jpg",
    "text": "",
    "variants": []
  },
  {
    "title": "SMC4-MC4 Dişi-Erkek Bağlantı Konnektör Seti",
    "image": "https://cw-enerji.com/images/product/1_smc4-mc4-disi-erkek-baglanti-konnektoru-seti_0.jpg",
    "text": "- Bakır ve Gümüş Kaplama Bağlantı Malzemesi\n- Eklemeli Kilit Sistemi\n- Fiş Konnektörü Bağlantı Direnci : ≤ 5mΩ\n- Maksimum Sistem Voltajı : 1000V\n- Nominal Akım Kapasitesi:\n*22A(2,5mm2)\n*30A(4mm2, 6mm2)",
    "variants": []
  },
  {
    "title": "SMC4-BRANCH Dişi-Erkek Y Bağlantı Konnektör Seti",
    "image": "https://cw-enerji.com/images/product/5_smc4-y-branch-disi-erkek-y-konnektoru-seti_0.jpg",
    "text": "- Bakır ve Gümüş Kaplama Bağlantı Malzemesi\n- Eklemeli Kilit Sistemi\n- Fiş Konnektörü Bağlantı Direnci : ≤ 5mΩ\n- Maksimum Sistem Voltajı : 1000V\n- Nominal Akım Kapasitesi:\n*22A(2,5mm2)\n*30A(4mm2, 6mm2)",
    "variants": []
  },
  {
    "title": "Akü-Akü Arası 30cm Seri Bağlantı Seti",
    "image": "https://cw-enerji.com/images/product/162_aku-aku-arasi-30cm-seri-baglanti-seti_0.webp",
    "text": "",
    "variants": []
  },
  {
    "title": "Akü-Akü Arası 40cm Paralel Bağlantı Seti",
    "image": "https://cw-enerji.com/images/product/163_aku-aku-arasi-40cm-paralel-baglanti-seti_0.webp",
    "text": "",
    "variants": []
  },
  {
    "title": "Akü-İnverter(Akıllı) Arası 1.5m Bağlantı Seti",
    "image": "https://cw-enerji.com/images/product/164_aku-inverterakilli-arasi-15m-baglanti-seti_0.webp",
    "text": "",
    "variants": []
  },
  {
    "title": "Akü-İnverter(P,MS Serisi) Arası Bağlantı Seti",
    "image": "https://cw-enerji.com/images/product/210_aku-inverterpms-serisi-arasi-baglanti-seti_0.webp",
    "text": "",
    "variants": []
  },
  {
    "title": "Akü-Şarj Kontrol Cihazı Arası 1.5m Bağlantı Seti",
    "image": "https://cw-enerji.com/images/product/165_aku-sarj-kontrol-cihazi-arasi-15m-baglanti-seti_0.webp",
    "text": "",
    "variants": []
  },
  {
    "title": "Panel-Panel Arası 1.5 m Bağlantı Seti",
    "image": "https://cw-enerji.com/images/product/49_panel-panel-arasi-15-m-baglanti-seti_0.webp",
    "text": "",
    "variants": []
  },
  {
    "title": "Panel-İnverter Arası 10m Bağlantı Seti",
    "image": "https://cw-enerji.com/images/product/212_panel-inverter-arasi-10m-baglanti-seti_0.webp",
    "text": "",
    "variants": []
  },
  {
    "title": "Panel-İnverter Arası 5m Bağlantı Seti",
    "image": "https://cw-enerji.com/images/product/209_panel-inverter-arasi-5m-baglanti-seti_0.webp",
    "text": "",
    "variants": []
  },
  {
    "title": "Panel-Şarj Kontrol Cihazı Arası 10m Bağlantı Seti",
    "image": "https://cw-enerji.com/images/product/52_panel-sarj-kontrol-cihazi-arasi-10m-baglanti-seti_0.webp",
    "text": "",
    "variants": []
  },
  {
    "title": "Panel-Şarj Kontrol Cihazı Arası 5m Bağlantı Seti",
    "image": "https://cw-enerji.com/images/product/211_panel-sarj-kontrol-cihazi-arasi-5m-baglanti-seti_0.webp",
    "text": "",
    "variants": []
  },
  {
    "title": "TommaTech LiFePO4 Modüler Lityum Batarya Güç Kablosu",
    "image": "https://cw-enerji.com/images/product/942_tommatech-lifepo4-moduler-lityum-batarya-guc-kablosu_0.jpg",
    "text": "",
    "variants": []
  }
];

export default solarEkipman;
